export type Cliente = {
  id: string;
  nome: string;
  email: string;
  cpf: string;
  cpfresponsavel: string;
  nascimento: Date;
  sexo: 'm' | 'f';
  telefone: string;
  observacoes: string;
  origem: string;

  dataCadastro: Date;
  usuarioCadastro: string;
  
  endereco_id: string;
  endereco: Endereco;
  enderecos?: ClienteEndereco[];
  total_pedidos?: number;
  ultimo_pedido?: Date | string;
  cidade?: string;
  bairro?: string;
  logradouro?: string;
  numero?: string | number;
  saldo_cashback?: number;
  total_cashback_acumulado?: number;
  total_cashback_resgatado?: number;
}

export type Endereco = {
  id: string;
  cep: string;
  logradouro: string;
  numero: number | string;
  complemento: string;
  bairro: string;
  cidade: string;
}

export type ClienteEndereco = {
  id?: string;
  cliente_id: string;
  titulo?: string;
  cep?: string;
  logradouro: string;
  numero: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  referencia?: string;
  padrao?: boolean;
  ativo?: boolean;
  criado_em?: Date;
}

export type Produto = {
  id: string;
  titulo: string;
  descricao: string;
  foto_url?: string;
  fotos?: string[];
  tamanhos: ProdutoTamanho[];
  categoria_id?: string;
  categoria_nome?: string;
  ordem?: number;
  visivel: boolean;
  is_kit?: boolean;
  itens?: any[];
  gerenciar_estoque?: boolean;
  quantidade_atual?: number;
  faixa_etaria?: string;
  tags_nutricionais?: string[];
};

export type ProdutoTamanho = {
  id: string;
  produto_id: string;
  nome: string;
  valor: number;  
  valor_desconto?: number;
  ordem?: number | boolean;
  visivel: boolean;
  gerenciar_estoque?: boolean;
  quantidade_atual?: number;
};

export type ProdutoForm = {
  id: string;
  titulo: string;
  descricao: string;
  foto_url?: string;
  fotos?: string[];
  tamanhos: string;
  categoria_id?: string;
  faixa_etaria?: string;
  tags_nutricionais?: string[];
};

export { type HorarioFuncionamento, type HorarioExcecao } from '@/app/lib/definitions';
export * from './produto/nutricaoUtils';